import { toast } from "sonner";
import { api } from "@/lib/api";

// Builds the AML ID request, logs it, and opens WhatsApp with the message ready.
export async function openIdRequest({ phone, customer_name, branch, reason, kyc_id }) {
  try {
    const { data } = await api.post("/cash-watch/id-request", {
      phone,
      customer_name,
      branch,
      reason: reason || "",
      kyc_id: kyc_id || "",
    });
    const digits = String(phone || "").replace(/\D/g, "");
    const intl = digits.startsWith("61") ? digits : `61${digits.replace(/^0+/, "")}`;
    window.open(`https://wa.me/${intl}?text=${encodeURIComponent(data.message)}`, "_blank");
    return data;
  } catch {
    toast.error("Could not build the ID request link");
    return null;
  }
}
